import { format, isToday, isTomorrow, parseISO } from "date-fns";

export const renderDate = (date) => {
    const parsedDate = parseISO(date);
    if (isToday(parsedDate)) return "Today";
    if (isTomorrow(parsedDate)) return "Tomorrow";
    return format(parsedDate, "EEE d MMM");
};

export const getTime = (sessionDate) => {
    if (!sessionDate) {
        return "";
    }
    const cleanDate = String(sessionDate).replace(/(?:Z|[+-]\d{2}:?\d{2})$/i, "");
    const date = parseISO(cleanDate);
    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return format(date, "h:mm a").toLowerCase();
};
